import React, { useState } from 'react';
import close from "../../assets/close.svg";

import "./TaskBlock.css";

const TaskBlock = ({ task }) => {
    const [open, setOpen] = useState(true)
    const info = task && task.info ? task.info : 'The task “Update Rid Service…” has been succesfully created'
    const link = task && task.link ? task.link : 'https://zira.zstream.io/app/tasks/task/ZAZPOC-231'
    const title = task && task.title ? task.title : 'ZAZPOC-231'

    return (
        <>
            {
                open ? (
                    <div className='task-block' >
                        <div className='close' onClick={() => setOpen(false)}>
                            <img src={close} alt="close" />
                        </div>
                        <div className='task-info'>
                            {info}, <a href={link} target='_banck'>{title}</a>
                        </div>
                    </div >
                ) : (null)
            }
        </>
    );
};
export default TaskBlock;